var map = {
	"./ddzxb-green.png": 66445,
	"./ddzxb.png": 51335,
	"./gyszd-green.png": 77056,
	"./gyszd.png": 61838,
	"./khzd-green.png": 93022,
	"./khzd.png": 64243,
	"./labor-cost-green.png": 47641,
	"./labor-cost.png": 63659,
	"./labor-order-green.png": 60624,
	"./labor-order.png": 21726,
	"./labor-wage-green.png": 99198,
	"./labor-wage.png": 11072,
	"./material-detail-green.png": 41830,
	"./material-detail.png": 1480,
	"./material-summary-green.png": 98785,
	"./material-summary.png": 22803,
	"./project-coast-green.png": 99503,
	"./project-coast.png": 86541,
	"./project-pay-details-green.png": 33546,
	"./project-pay-details.png": 15652,
	"./project-payable-green.png": 88731,
	"./project-payable.png": 69505,
	"./project-receivable-green.png": 51839,
	"./project-receivable.png": 8477,
	"./project-report-green.png": 59235,
	"./project-report.png": 48169,
	"./project-stage-statistics-green.png": 67751,
	"./project-stage-statistics.png": 70533,
	"./project-start-statistics-green.png": 3317,
	"./project-start-statistics.png": 79919,
	"./project-visa-green.png": 68134,
	"./project-visa.png": 23496,
	"./xmcbhzb-green.png": 61179,
	"./xmcbhzb.png": 57697,
	"./zjszmxb-green.png": 33295,
	"./zjszmxb.png": 90253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3692;